document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuToggle = document.querySelector('.header-mobile-menu-toggle');
  const mobileMenu = document.querySelector('.header-navigation');
  const mobileMenuOverlay = document.querySelector('.header-overlay');
  const mobileMenuClose = document.querySelector('.header-mobile-menu-close');

  const MOBILE_BREAKPOINT = 1024;
  const HOVER_BREAKPOINT = 1440;

  let isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  let isHoverDesktop = window.innerWidth >= HOVER_BREAKPOINT;
  let isClickDesktop = window.innerWidth >= MOBILE_BREAKPOINT && window.innerWidth < HOVER_BREAKPOINT;

  let resizeTimeout;
  let leaveTimeout;

  const navigation = document.querySelector('.header-navigation');
  const navigationItems = document.querySelectorAll('.navigation-item');
  const navigationSubMenus = document.querySelectorAll('.navigation-item-sub-menu');

  /* ========== UTILS ========== */

  const debounceResize = (callback, delay = 150) => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(callback, delay);
  };

  const removeAllActiveSubMenus = () => {
    navigationSubMenus.forEach(subMenu => {
      subMenu.classList.remove('navigation-item-sub-menu--active');
    });
  };

  const showAllSubMenus = () => {
    navigationSubMenus.forEach(subMenu => {
      if (!subMenu.classList.contains('navigation-item-sub-menu--empty')) {
        subMenu.classList.add('navigation-item-sub-menu--visible');
      }
    });
  };

  const hideAllSubMenus = () => {
    navigationSubMenus.forEach(subMenu => {
      subMenu.classList.remove('navigation-item-sub-menu--visible');
    });

    navigationItems.forEach(item => {
      item.classList.remove('navigation-item--active');
    });

    setTimeout(() => {
      navigationSubMenus.forEach(subMenu => {
        subMenu.classList.remove('navigation-item-sub-menu--active');
      });
    }, 300);
  };

  const showOnlySubMenu = (targetSubMenu, targetItem) => {
    navigationSubMenus.forEach(subMenu => {
      subMenu.classList.remove('navigation-item-sub-menu--visible');
      subMenu.classList.remove('navigation-item-sub-menu--active');
    });

    navigationItems.forEach(item => {
      item.classList.remove('navigation-item--active');
    });

    if (targetSubMenu && targetItem) {
      targetSubMenu.classList.add('navigation-item-sub-menu--active');
      targetSubMenu.classList.add('navigation-item-sub-menu--visible');
      targetItem.classList.add('navigation-item--active');
    }
  };

  // Find submenu as a sibling (not necessarily immediate)
  const getSubMenuForItem = (item) => {
    if (!item || !item.parentElement) return null;

    return Array.from(item.parentElement.children).find(el =>
      el.classList.contains('navigation-item-sub-menu') &&
      el !== item
    );
  };

  const isSubMenuEmpty = (subMenu) => {
    if (!subMenu) return true;

    const menus = subMenu.querySelector('.navigation-item-menus');
    if (!menus) return true;

    return menus.children.length === 0;
  };

  /* ========== EMPTY SUB-MENU CHECK (ON LOAD) ========== */

  navigationSubMenus.forEach(subMenu => {
    if (isSubMenuEmpty(subMenu)) {
      subMenu.classList.add('navigation-item-sub-menu--empty');
    }
  });

  /* ========== MOBILE MENU ========== */

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('header-navigation--visible');
      mobileMenuOverlay.classList.toggle('header-overlay--visible');
    });
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('header-navigation--visible');
      mobileMenuOverlay.classList.remove('header-overlay--visible');
      resetAllMenus();
    });
  }

  const resetAllMenus = () => {
    const allMenuLinks = document.querySelectorAll('.nav-item-menu-links');
    allMenuLinks.forEach(menuLink => {
      menuLink.classList.remove('nav-item-menu-links--active');
    });

    hideAllSubMenus();
  };

  /* ========== CLICK (MOBILE + TABLET) ========== */

  navigationItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const subMenu = getSubMenuForItem(item);

      if (!subMenu || subMenu.classList.contains('navigation-item-sub-menu--empty')) {
        return;
      }

      // MOBILE (<1024)
      if (isMobile) {
        item.classList.toggle('navigation-item--active');
        subMenu.classList.toggle('navigation-item-sub-menu--visible');
        return;
      }

      // TABLET / SMALL DESKTOP (1024–1439)
      if (isClickDesktop) {
        e.preventDefault();

        const isActive = subMenu.classList.contains('navigation-item-sub-menu--active');

        if (isActive) {
          hideAllSubMenus();
        } else {
          showOnlySubMenu(subMenu, item);
        }
      }
    });
  });

  /* ========== DESKTOP HOVER (≥1440px ONLY) ========== */

  const addDesktopHoverEvents = () => {
    navigationItems.forEach(item => {
      item.onmouseenter = () => {
        if (!isHoverDesktop) return;

        clearTimeout(leaveTimeout);

        const subMenu = getSubMenuForItem(item);

        if (!subMenu || subMenu.classList.contains('navigation-item-sub-menu--empty')) {
          hideAllSubMenus();
          return;
        }

        removeAllActiveSubMenus();
        subMenu.classList.add('navigation-item-sub-menu--active');

        requestAnimationFrame(() => {
          showAllSubMenus();
          item.classList.add('navigation-item--active');
        });
      };

      item.onmouseleave = () => {
        if (!isHoverDesktop) return;

        leaveTimeout = setTimeout(() => {
          hideAllSubMenus();
        }, 300);
      };
    });

    navigationSubMenus.forEach(subMenu => {
      subMenu.onmouseenter = () => {
        if (!isHoverDesktop || subMenu.classList.contains('navigation-item-sub-menu--empty')) return;

        clearTimeout(leaveTimeout);

        const navItem = Array.from(navigationItems).find(item => {
          return getSubMenuForItem(item) === subMenu;
        });

        if (navItem) {
          removeAllActiveSubMenus();
          subMenu.classList.add('navigation-item-sub-menu--active');

          requestAnimationFrame(() => {
            showAllSubMenus();
            navItem.classList.add('navigation-item--active');
          });
        }
      };

      subMenu.onmouseleave = () => {
        if (!isHoverDesktop) return;

        leaveTimeout = setTimeout(() => {
          hideAllSubMenus();
        }, 300);
      };
    });
  };

  const removeDesktopHoverEvents = () => {
    navigationItems.forEach(item => {
      item.onmouseenter = null;
      item.onmouseleave = null;
    });

    navigationSubMenus.forEach(subMenu => {
      subMenu.onmouseenter = null;
      subMenu.onmouseleave = null;
    });

    hideAllSubMenus();
  };

  /* ========== CLICK OUTSIDE TO CLOSE (DESKTOP + TABLET) ========== */

  document.addEventListener('click', (e) => {
    if (isMobile) return;

    if (!navigation.contains(e.target)) {
      hideAllSubMenus();
    }
  });

  /* ========== ESC KEY SUPPORT ========== */

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      hideAllSubMenus();

      if (mobileMenu) mobileMenu.classList.remove('header-navigation--visible');
      if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('header-overlay--visible');
    }
  });

  /* ========== INIT ========== */

  if (isHoverDesktop) {
    addDesktopHoverEvents();
  }

  /* ========== RESIZE ========== */

  window.addEventListener('resize', () => {
    debounceResize(() => {
      const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
      const newIsHoverDesktop = window.innerWidth >= HOVER_BREAKPOINT;
      const newIsClickDesktop = window.innerWidth >= MOBILE_BREAKPOINT && window.innerWidth < HOVER_BREAKPOINT;

      const modeChanged =
        newIsMobile !== isMobile ||
        newIsHoverDesktop !== isHoverDesktop ||
        newIsClickDesktop !== isClickDesktop;

      if (!modeChanged) return;

      isMobile = newIsMobile;
      isHoverDesktop = newIsHoverDesktop;
      isClickDesktop = newIsClickDesktop;

      removeDesktopHoverEvents();

      if (isHoverDesktop) {
        addDesktopHoverEvents();
      }
    });
  });

  /* ========== SUB-MENU CLOSE BUTTONS ========== */

  const subMenuCloses = document.querySelectorAll('.navigation-item-sub-menu-close');

  subMenuCloses.forEach(close => {
    close.addEventListener('click', () => {
      const subMenu = close.closest('.navigation-item-sub-menu');

      const navItem = Array.from(navigationItems).find(item => {
        return getSubMenuForItem(item) === subMenu;
      });

      if (navItem) {
        navItem.classList.remove('navigation-item--active');
      }

      if (subMenu) {
        subMenu.classList.remove('navigation-item-sub-menu--visible');
        subMenu.classList.remove('navigation-item-sub-menu--active');
      }
    });
  });

  /* ========== NAV ITEM MENU ACCORDION (TERTIARY) ========== */

  const navItemMenuTitles = document.querySelectorAll('.nav-item-menu-title');

  navItemMenuTitles.forEach(title => {
    title.addEventListener('click', () => {
      const menuLinks = title.nextElementSibling;

      if (menuLinks && menuLinks.classList.contains('nav-item-menu-links')) {
        menuLinks.classList.toggle('nav-item-menu-links--active');
      }
    });
  });

  const navItemMenuBackButtons = document.querySelectorAll('.nav-item-menu-back');

  navItemMenuBackButtons.forEach(backButton => {
    backButton.addEventListener('click', (e) => {
      e.stopPropagation();

      const menuLinks = backButton.closest('.nav-item-menu-links');

      if (menuLinks) {
        menuLinks.classList.remove('nav-item-menu-links--active');
      }
    });
  });
});
